export enum BunnyLibraryTypes {
    COURSE_INTRO = 'course-intro',
    COURSE_CONTENT = 'course-content',
    STANDALONE_LIBRARY_CONTENT = 'standalone-library-content',
}